import { Block } from 'baseui/block'
import Layout from '../../components/Layout'
import { Button, SIZE } from 'baseui/button'
import ContentHeader from '../../components/ContentHeader'
import React from 'react'
import { ChevronRight } from 'baseui/icon'
import { ListItem, ListItemLabel } from 'baseui/list'
import { useQuery } from 'react-query'
import { listEmailTemplates } from '../../core/apis'
import { Link, useNavigate } from 'react-router-dom'
import routes from '../../routes'

export default function EmailTemplateList({ props }) {
	const { isLoading, data = [] } = useQuery('listEmailTemplates', listEmailTemplates)
	const navigate = useNavigate()
	function handleClick() {
		navigate(routes.emailTemplatesCreate)
	}
	return (
		<Layout>
			<ContentHeader
				title={'템플릿 관리'}
				style={{paddingTop: '57px', paddingBottom: '10px', flexDirection: 'column', alignItems: 'flex-start' }}
				actions={
					<Button size={SIZE.compact} onClick={handleClick} $style={{ paddingLeft: '20px', paddingRight:'20px' ,borderRadius: '3px', transform: 'translateY(8px)' }}>
						추가
					</Button>
				}
			/>
			<Block
				$style={{
					borderRadius: '10px',
					borderTop: '1px solid rgba(0, 0, 0, 0.08)',
					boxShadow: 'rgb(225 225 225 / 40%) 0px 3px 10px',
					overflow: 'hidden',
					paddingBottom: '70px',
				}}
			>
				{data.map((row, i) => (
					<Link className='link-template' to={`${routes.emailTemplates}/${row.id}`} key={row.id} style={{ textDecoration: 'none' }}>
						<ListItem
							overrides={{
								Content: {
									style: {
										padding: '0',
										minHeight: '55px',
										marginLeft: '0',
										fontSize: '15px',
										borderBottom: '1px solid rgba(0,0,0,0.08)',
									},
								},
							}}
						>
							<ListItemLabel
								overrides={{
									LabelContent: {
										style: {
											fontSize: '16px',
											'@media screen and (max-width: 768px)': {
												fontSize: '14px',
											},
										},
									},
								}}
							>
								{row.name}
							</ListItemLabel>
						</ListItem>
					</Link>
				))}
			</Block>
		</Layout>
	)
}
